import { useCheckoutStore } from "@/store/checkout";

export const pageCommanderCreationCompteProps = () => ({
  typePanier: {
    type: String,
    required: false,
    default: "drive"
  },
  isInTunnel: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const usePageCommanderCreationCompte = (erreurCreationCarteRef) => {
  const checkoutStore = useCheckoutStore();
  const carteDejaExistante = ref(false);
  const { setStepValue, setStepMode } = checkoutStore;
  const router = useRouter();

  const handleAccountCreated = (data) => {
    if (data.creationCarteError) {
      carteDejaExistante.value = data.creationCarteDejaExistante;
      erreurCreationCarteRef.value.show();
    } else {
      redirectToCommander();
    }
  }
  const redirectToCommander = () => {
    router.replace("/commander");
  }
  const redirectToSuccess = (data) => {
    router.replace(`/confirmation-creation-compte?${data && data.creationCarteError ? 'erreur=1' : ''}${data && data.creationCarteDejaExistante ? '&carteExistante=1' : ''}`);
  }
  const mounted = () => {
    setStepValue(0);
    setStepMode("inscription");
  }

  return {
    carteDejaExistante,
    handleAccountCreated,
    redirectToCommander,
    redirectToSuccess,
    mounted
  }
}